export function loggedIn(state) {
  return state.token !== null;
}
export function token(state) {
  return state.token;
}
